import { FC, useEffect, useState } from "react";
import "./ModalLinkingCategoriesInsert.scss";
import ModalDefault from "../../../ModalDefault/ModalDefault";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { Card, Col, Row } from "react-bootstrap";
import { schema } from "./Validate";
import { PlansModel } from "../../../../models/Financial/Plans/PlansModel";
import { useAgentsCategories } from "../../../../providers/Agents/AgentsCategories/AgentsCategoriesProvider";
import { usePlanAgentsCategories } from "../../../../providers/Financial/Plans/PlanAgentsCategories/PlanAgentsCategoriesProvider";
import SkeletonTable from "../../../SkeletonTable/SkeletonTable";

interface ModalLinkingCategoriesInsertProps {
  show: boolean;
  onClose: () => void;
  plan?: PlansModel;
}

const ModalLinkingCategoriesInsert: FC<ModalLinkingCategoriesInsertProps> = ({
  show,
  onClose,
  plan,
}) => {
  const [isLoadingSubmit, setIsLoadingSubmit] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [categories, setCategories] = useState<any[]>([]);

  const { setParams: setParamsAgentsCategories, categoriesOptions } =
    useAgentsCategories();
  const { handleFetch, setError, setParams, params, categoriesRegistrait } =
    usePlanAgentsCategories();

  const {
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(schema),
  });

  const reset = () => {
    setCategories([]);
    setValue("plan_id", 0);
    setValue("agent_ids", []);
    setIsLoading(false);
  };

  const handleClose = () => {
    reset();
    onClose();
  };

  const onSubmit = async (data: any) => {
    setIsLoadingSubmit(true);
    setError("");

    const ret = await handleFetch(data as any);

    if (ret) {
      toast.success("Vinculação salva com sucesso!");
      handleClose();
    }

    setIsLoadingSubmit(false);
  };

  const handleSelectedCategories = (item: any) => {
    if (!item) return;

    const exist = categories?.some((c) => c === item?.value);

    if (exist) {
      setCategories((cat) => cat.filter((c) => c !== item?.value));
    } else {
      setCategories((cat) => [...cat, item.value]);
    }
  };

  const handleSelectAll = () => {
    const allIds = categoriesOptions.map((c) => c.value);

    const allSelected = allIds.every((id) => categories.includes(id));

    if (allSelected) {
      setCategories([]);
    } else {
      setCategories(allIds);
    }
  };

  useEffect(() => {
    if (show) {
      if (plan?.id) {
        setIsLoading(true);
        setValue("plan_id", plan?.id);
        setParams({
          ...params,
          page: 1,
          withPaginate: false,
          filter: { plan_id: plan?.id },
        });
        setParamsAgentsCategories({
          withPaginate: false,
          filter: { only_active: true },
        });
      } else {
        reset();
      }
    }
  }, [show]);

  useEffect(() => {
    if (categoriesOptions.length) {
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    }
  }, [categoriesOptions]);

  useEffect(() => {
    setValue("agent_ids", categories);
  }, [categories]);

  useEffect(() => {
    if (categoriesRegistrait?.length) {
      const ids = categoriesRegistrait.map((c) => c.agent_id);
      setCategories(ids);
    }
  }, [categoriesRegistrait]);

  return (
    <ModalDefault
      title="Adicionar Vinculo de Categorias para IA"
      show={show}
      onClose={handleClose}
      sizeModal={"lg"}
      showFooter={true}
      buttonText={isLoadingSubmit ? "Salvando..." : "Salvar"}
      showButtonSpinner={isLoadingSubmit}
      disabledSubmit={isLoadingSubmit}
      handleSubmit={handleSubmit(onSubmit)}
      backdrop="static"
      backgroundColor="#f8f9fa"
    >
      <div
        className="ModalLinkingCategoriesInsert"
        data-testid="ModalLinkingCategoriesInsert"
      >
        <Card>
          <Card.Body>
            <Row style={{ display: isLoading ? "none" : "flex" }}>
              <Col md={12}>
                <div className="form-check">
                  <input
                    className="form-check-input mb-4"
                    type="checkbox"
                    id="selectAll"
                    name="selectAll"
                    onChange={handleSelectAll}
                    checked={
                      categoriesOptions.length > 0 &&
                      categoriesOptions.every((c) =>
                        categories.includes(c.value),
                      )
                    }
                    disabled={isLoading}
                  />
                  <label className="form-check-label">Selecionar Todos</label>
                </div>
              </Col>
            </Row>
            <Row>
              {!isLoading ? (
                <>
                  {categoriesOptions?.map((x) => (
                    <Col md={4} className="mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id={x?.value}
                          name={x?.label}
                          onClick={() => handleSelectedCategories(x)}
                          checked={categories.includes(x.value)}
                        />
                        <label className="form-check-label">{x?.label}</label>
                      </div>
                    </Col>
                  ))}
                </>
              ) : (
                <SkeletonTable columns={4} />
              )}
            </Row>
          </Card.Body>
        </Card>
      </div>
    </ModalDefault>
  );
};

export default ModalLinkingCategoriesInsert;
